import { render, staticRenderFns } from "./GooglePlayBadge.vue?vue&type=template&id=3c557f83&"
import script from "./GooglePlayBadge.vue?vue&type=script&lang=js&"
export * from "./GooglePlayBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports